<template>
  <a-modal
    :visible="visible"
    @cancel="handleClose"
    width="max-content"
    :title="`Visualización del flujo de chatbot - ${chatbot.name}`"
    :bodyStyle="bodyStyle"
    centered
  >
    <div class="preview-container">
      <container-tree v-if="chatbot.id" :chatbotId="chatbot.id" :disabled-actions="true" />
    </div>

    <template #footer>
      <a-button @click="handleClose"> Cerrar visualización </a-button>
      <a-button type="primary" :disabled="disabled" @click="handleGoToEdit">
        Editar chatbot
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import ContainerTree from "@/app/chatbots/components/tree/ContainerTree.vue";
import moment from "moment";
import { ChatbotStatus } from "@/app/chatbots/utils/enums";

export default {
  name: "ModalPreviewChatbot",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    chatbot: { type: Object, required: true },
  },
  components: {
    ContainerTree,
  },
  data: () => ({
    moment,
    count: 0,
    bodyStyle: {
      height: "70vh",
      maxHeight: "80vh",
      maxWidth: "710px",
      minWidth: "34rem",
      padding: "0",
    },
  }),
  computed: {
    disabled() {
      return this.chatbot.status === ChatbotStatus.Active;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleGoToEdit() {
      this.$router.push(`/chatbots/tree/${this.chatbot.id}`);
    },
  },
};
</script>

<style lang="sass" scoped>
.preview-container
  overflow: auto
  height: 100%
  padding: 26px

.modal__title
  width: 90%

.preview-container::-webkit-scrollbar
  height: 8px
  width: 8px

.preview-container::-webkit-scrollbar-track
  background: transparent

.preview-container::-webkit-scrollbar-thumb
  background-color: #c1c1c1
  border-radius: 4px

/* Works on Firefox */
.preview-container
  scrollbar-width: thin
  scrollbar-color: #c1c1c1 transparent
</style>
